import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className="ri-compasses-2-line text-3xl"></i>
      </span>
      <h1 className="mt-6 text-4xl font-black text-foreground-950">404</h1>
      <p className="mt-3 text-base font-medium text-foreground-800">页面走丢了</p>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        你访问的页面不存在或已被移除，回到首页继续发现好看的影视内容吧。
      </p>
      <Link
        to="/"
        className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
      >
        <i className="ri-home-4-line"></i>
        返回首页
      </Link>
    </div>
  );
}